import {
  UPDATE_ASSESSMENTS_LIST,
  TOGGLE_ASSESSMENTS_LIST_LOADING,
  ASSESSMENTS_LIST_ERROR,
  ASSESSMENTS_UPDATE_TOTAL_LIST,
} from "../actions/dataEntryAssessmentActions";

const initState = {
  name: "Data Entry Assessments",
  assessments: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
  },
};

const dataEntryAssessmentReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_ASSESSMENTS_LIST:
      newState.assessments.list = action.payload.value;
      break;
    case TOGGLE_ASSESSMENTS_LIST_LOADING:
      newState.assessments.loading = action.payload.value;
      break;
    case ASSESSMENTS_LIST_ERROR:
      newState.assessments.error = action.payload.value;
      break;
    case ASSESSMENTS_UPDATE_TOTAL_LIST:
      newState.assessments.totalRecords = action.payload.value;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntryAssessmentReducer;
